import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { Button } from 'react-toolbox/lib/button';
import Spinner from './Spinner';
import styles from './LoadingButton.scss';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  raised: PropTypes.bool,
  accent: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

const LoadingButton = props => {
  const { isLoading, children, disabled, onClick, className, ...attrs } = props;
  const classes = classNames(className, styles.root, {
    [styles.isLoading]: isLoading,
  });
  const loadingIcon = isLoading ? <Spinner className={styles.spinner} /> : null;
  return (
    <Button
      raised
      accent
      disabled={disabled}
      onClick={onClick}
      className={classes}
      {...attrs}
    >
      {loadingIcon}
      {children}
    </Button>
  );
};

LoadingButton.propTypes = propTypes;

export default LoadingButton;



// WEBPACK FOOTER //
// ./src/client/src/components/LoadingButton.js